import { render } from "./ModReasonModal.vue?vue&type=template&id=8d660d50"
import script from "./ModReasonModal.vue?vue&type=script&lang=js"
export * from "./ModReasonModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__